export default __webpack_public_path__ + "static/media/add.94c8a526.png";